<template>
   <div class="container px-0 bg-danger">
   <div class="offcanvas offcanvas-end rounded-2 shadow" 
         data-bs-scroll="true" 
         data-bs-backdrop="false" 
         tabindex="-1" 
         id="offcanvasCheckList" 
         aria-labelledby="offcanvasCheckListLabel"
      >
      <!--
         @blur="focusOff()"
      -->
      <div class="offcanvas-header">
         <h6 id="offcanvasCheckListLabel">CheckList ({{cnttId}})</h6>
         <button type="button" class="btn-close btn-sm text-reset" data-bs-dismiss="offcanvas" aria-label="Close" ref="btn_out_offcanvas"></button>
      </div>
      <hr class="m-0"/>
      <div class="offcanvas-body gap-0">
                     <!--
                     <button class="btn btn-sm btn-info col-3 col-md-12" 
                           type="button" 
                           @click="switchCheckList()"
                           >
                        {{textCheckList}} CheckList
                     </button>
                     -->
         <div class="row px-1 pt-2">
            <div class="fp-onOff btn-info rounded" @click="switchCheckList()">
              {{textCheckList}} CheckList
            </div>
         </div>
      </div>
         <!--
         -->
   </div>
   </div>
</template>

<script>
//import { ref, nextTick, watchEffect } from 'vue';
import { ref, onMounted } from 'vue'
import { useStore } from 'vuex'

import WspService from "../workSpace.service";

export default {
   setup() {
      const store = useStore()
      const cnttId = ref(store.state.wspace.contentId)
      const boardId = ref(null)
      const btn_out_offcanvas = ref(null)
      const cellId = ref(0)
      const content = ref({})
      const textCheckList = ref('Agregar')

      onMounted(() => {
         let myOffCanvas = document.getElementById('offcanvasCheckList')
         myOffCanvas.addEventListener('shown.bs.offcanvas', function (event) {
         console.log(store.state.wspace.contentId)
         cnttId.value = store.state.wspace.contentId
         let button = event.relatedTarget
         cellId.value = button.getAttribute('data-cell-id')
         boardId.value = WspService.getBoardId(store)
         getContent(cnttId.value)
         myOffCanvas.focus()
         console.log(" show ckeckList's OC")
         })
         console.log("checkList's OC")
      })
      
      function getContent(contentId) {
         WspService.getContent(contentId)
         .then(response => {
            console.log(response.data)
            content.value = response.data
            //
            textCheckList.value = content.value.enableCheckList ? 'Quitar' : 'Agregar'
            //
            console.log("content ok: "+content.value.title)
         })
         .catch(error => {
            console.log(error);
         });
      }
      
      function setColorId (colorId) {
         let cnttData = {}
            cnttData.fpColorId = colorId
         WspService.upContent(
            cnttId.value,    // contentId,
            cellId.value,    // cellId,
            boardId.value,   // boardId
            'FPC',   // code
            cnttData    // cnttData
         )
         .then(response => {
            getContent(response.data)
            store.dispatch("wspace/setContentId", -2)
            //
            //setTimeout(getContent(response.data),125)
            //
         })
         .catch(error => {
            console.log(error);
         });
      }

      function switchCheckList() {
         content.value.enableCheckList = !content.value.enableCheckList
         textCheckList.value = content.value.enableCheckList ? 'Quitar' : 'Agregar'
         store.dispatch("wspace/setContentId", -5)
      }
      /*
      */
      function focusOff() {
         setTimeout(btn_out_offcanvas.value.click(),125)
      }

      return {
         btn_out_offcanvas,
         focusOff,
         cellId,
         cnttId,
         content,
         setColorId,
         switchCheckList,
         textCheckList,
      }
   }
}
</script>

<style scoped>
.offcanvas-end {
  top: 150px;
  right: 100px;
  width: 350px;
  height: fit-content;
}
.btn-info {
   background-color: #e5e7e9;
   border-color: #e5e7e9 ;
}
.btn-info:hover {
   background-color:  #cacfd2 ;
}
.btn-sm {
   width: max-content;
}
.fp-bg-color {
  width: 60px;
  height: 40px;
}
.fp-onOff {
  width: 333px;
  height: 30px;
  text-align: center;
}
</style>